import { reportError, reportWarning } from 'src/dataLayer/remoteData/rollbar/reporter';

import { TrackerFailureError, AbTesterFailureError, ValidationErrorPayload, ReportError } from './types';
import { RequestParams, UnsuccessfulResponseError } from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest/types';

const reportUnsuccessfulRequest = (error: UnsuccessfulResponseError, requestParams: RequestParams): ReportError =>
  reportError('api:call:failed', { error, requestParams });

const reportUnsuccessfulResponse = (
  error: UnsuccessfulResponseError, requestParams: RequestParams
): ReportError => {
  const message = error?.response?.status ? `api:response:${error.response.status}` : 'api:response:unknown';
  return reportWarning(message, { error, requestParams });
};

export const reportAPIFailure = (error: UnsuccessfulResponseError, requestParams: RequestParams): ReportError => {
  if (error.response) {
    /*
    * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    return reportUnsuccessfulResponse(error, requestParams);
  }
  /*
    * The request was made but no response was received,
    * `error.request` is either an instance of XMLHttpRequest
    * or `error` is a generic error
    */
  return reportUnsuccessfulRequest(error, requestParams);
};

export const reportValidationError = (
  message: string,
  payload: ValidationErrorPayload,
  eventName?: string,
): ReportError =>
  reportError('event:validation:failed', {
    eventName,
    payload,
    error: {
      message,
    }
  });

export const reportTrackerFailure = (
  error: TrackerFailureError, eventName: string, payload: ValidationErrorPayload): ReportError =>
  reportError('tracker:failed', {
    eventName,
    payload,
    error: {
      message: error.message || error as unknown as string,
      status: error.status,
      readyState: error.readyState
    }
  });

/**
 * Reports failures on AB Tester. If the error contains customData
 * it will attach it as the payload.
 *
 * customData is attached by @lessonnine/ab-tester.api.js
 */

export const reportAbTesterFailure = (error: AbTesterFailureError): ReportError => {
  const payload = { ...error.customData };
  return reportError('ab-tester:call:failed', { error, payload });
};
